export default ({ schedulerReact }) => ({
  radio: {
    marginBottom: 10
  },
  radioLabel: {
    marginRight: 5,
    marginBottom: 10
  },
  radioLegend: {
    marginLeft: -5
  },
  occurrences: {
    display: 'flex',
    padding: 0,
    '&:focus': {
      outline: 0
    }
  },
  occurrenceInput: {
    display: 'inline-flex',
    marginBottom: 0,
    marginRight: 5,

    '& input': {
      width: 50
    }
  },
  occurrenceLabel: {
    fontFamily: schedulerReact.fontFamily,
    fontSize: 14,
    marginTop: -7
  },
  occurrenceText: {
    display: 'inline-block',
    marginRight: 5
  },
  endSelected: {
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: schedulerReact.fontFamily,
    fontSize: 14,
    width: '100%',
    padding: 0,
    '&:focus': {
      outline: 0
    }
  },
  complexDatepicker: {
    flex: '1 1 auto',
    width: '100%'
  },
  '@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)': { // IE11 fix for centered text
    occurrences: {
      paddingTop: 7,
      marginTop: -7
    },
    occurrenceText: {
      position: 'relative',
      top: 4
    }
  }
});
